import { useRef } from 'react'

const Iframe = ({ source }) => {
  const docsRef = useRef(null)

  //for ringleDocs//
  const dispatchToken = () => {
    try {
      docsRef.current.contentWindow.postMessage('123123123', '*')
    } catch (err) {
      console.log(err)
    }
  }

  if (!source) {
    return <div>Loading...</div>
  }
  return (
    <iframe
      ref={docsRef}
      src={source}
      onLoad={dispatchToken}
      className="border-none"
      width="100%"
      height="100%"
      title={'myframe'}
    />
  )
}

export default Iframe
